import request from '@/utils/request'

// 单轮非流式有角色问答
export function panguAISingleByRole(data) {
    const headers = new Headers({
        "Content-Type": "application/json"
    });
    return request({
        url: data.url,
        headers,
        method: 'post',
        data: processDataSingleByRole(data.data)
    })
}

// 处理单轮非流式有角色问答的请求数据
function processDataSingleByRole(data) {
    let [question, text] = data.split('********')
    return { 
        "messages": [ 
          { 
              "role": "system", 
              "content": text.substr(0, 4000)
           }, 
          { 
              "role": "user", 
              "content": question.substr(0, 4000)
          } 
          ], 
        "temperature": 0.9, 
        "max_tokens": 600,
        "stream": "false",
        
     }
}

// 单轮流式问答
export class panguMultiStream {
	constructor(options) {
        this.controller = null
        // this.options = options
        this.session_hash = options.session_hash
        this.url = options.url
        this.message = options.message
        this.history = options.history
        this.data = []
        this.finish = false
        this.callback = options.callback
        let [question, fulltext] = this.message.split('********')
        this.question = question || ''
        this.fulltext = fulltext || ''
        this.vector_text = options.vector_text || '',
        this.typec = options.typec || ''
        this.generateMessage()
        this.initFetch()
	}
	initFetch() {
    this.controller = new AbortController();
    const signal = this.controller.signal;
    // if (this.fulltext.length /1.5 > 2048) {
    //   Message({ showClose: true, message: '基于提问的案件的长度超出限制,会影响大模型回答的准确性', type: "info" })
    // }
    this.finish = false
    let _this = this
    fetch(this.url, {
    method: 'POST',
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json',
    },
    body: JSON.stringify({
        "messages": this.data, 
        "temperature": 0.3,  
        "max_tokens": 1000,  
        "stream": "true" ,
        "history": this.history,
        "sessionid": this.session_hash || '',
        vector_text: this.vector_text,
        needCallVector: true,
        typec: this.typec
    }),
    signal
    })
    .then(response => {
      console.log('response-------', response)
        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        function processStreamResult(result2) {
          const chunk = decoder.decode(result2.value, {
              stream: !result2.done
          });
          let lines = chunk.split('\n')
          lines.forEach( (item) => {
            let line = item.replace(/(\n)+$/, '')  // 去掉后面所有的\n字符
            if (line.trim().length > 0) {
              if (line.indexOf('[DONE]') > -1) {
                _this.finish = true // 避免遇到done以后还会继续发送换行空
                  //执行完成的页面逻辑
                _this.callback({
                  type: 'complete',
                  data: [[], [_this.question, '']] // 此结构为了兼容websocket数据处理
                })
                // 调试  err DOMException: BodyStreamBuffer was aborted
                result2.done = true
              } else if (!_this.finish) {
                var reg = /"choices": \[\{"message": {"content": "(.*?)"\}\}\]\}/g // 截取有效部分
                const matches = reg.exec(line)
                // matches && matches[1] && console.log('matches', matches[1])
                matches && matches[1] && _this.callback({
                  type: 'generating',
                  data: [[],[_this.question, matches[1].replace('\n', '')]] // 此结构为了兼容websocket数据处理
                });
              } 
            }
          })
          if (!result2.done) {
            return reader.read().then(processStreamResult);
          }
        }
        return reader.read().then(processStreamResult);
    })
    .catch(error => {
      _this.finish = true
      console.log('err', error)
      !_this.finish && _this.callback({
        type: 'error', 
        data: ['服务器端错误', '服务器端错误']
      })
    });
	}
	generateMessage() {
    this.data = []
      // sourceAI 与 judgeAi进行区分
    if (this.message.indexOf('********') > -1) {
      // 设定初始问答背景/前置
      this.data.push({"content": this.fulltext.substr(0, 2048 * 1.5)})
      // classify： 案例、法规等
      this.data.push({"content": '根据上面的内容提问'})
    }
    // 问答中不能出现空字符串，否则不会出答案
    this.history && this.history.length && this.history.forEach(item => {
      // if (item.question.trim().length && item.content.trim().length) {
        this.data.push({"content": item.question})
        item.content !== null && this.data.push({"content": item.content.replaceAll('"', '@@')})
      // }
    })
    this.data.push({"content": this.question})
	}
  close() {
    this.finish = true
    this.controller.abort();
  }
};
